import { render, staticRenderFns } from "./Competition.vue?vue&type=template&id=1ff7f22e&scoped=true"
import script from "./Competition.vue?vue&type=script&lang=js"
export * from "./Competition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff7f22e",
  null
  
)

export default component.exports